<script>
import PracticeInfoPreview from './PracticeInfoPreview.vue'

export default {
    extends: PracticeInfoPreview,
};
</script>
<template>
    <div class="mb-3">
        <Label :item="item"/>
        <div class="cards-scrollable-item">
            <a :href="selectedItem.link_url" tabindex="0" role="button" class="quick-link-card">
                <div class="quick-link-card-top join-the-practice" :style="{borderColor: bordercolor}">
                    <span class="svg-icon">
                        <img style="width: 60px;" :src="selectedItem.additionalProp1 && selectedItem.additionalProp1.icon">
                    </span>
                </div>
                <div class="quick-link-card-bottom font-weight-medium">
                    {{selectedItem.label}}
                </div>
            </a>
        </div>
    </div>
</template>
<style scoped>
.svg-icon {
    display: inline-block;
    position: relative;
}
.quick-link-card-top.join-the-practice {
    border-top: 4px solid;
    border-color: transparent !important;
    background-color: transparent;
}
.quick-link-card-top {
    height: 90px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.quick-link-card {
    display: block;
    width: 180px;
    text-decoration: none;
    transition: transform .2s ease-in;
    outline: none;
}
.quick-link-card-bottom {
    height: 62px;
    padding: 14px 16px;
    padding-top: 0;
    color: #333;
    font-size: 14px;
    text-align: center;
    text-transform: uppercase;
}
</style>
